export default __webpack_public_path__ + "static/media/ab-icon.fb4ab0a7.svg";